import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

const opacityAnimation = keyframes`
 0%, 100% { opacity: 1 }
 50% { opacity: .4 }
`;

const S = {
  Container: styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: ${tokens.spacer.x2};
    padding-left: ${tokens.spacer.x2};
    background: ${tokens.color.neutral_100};
  `,
  Anitmation: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    animation: ${opacityAnimation} 4s infinite;
  `,
  Fieldset: styled.div<{ showLabel: boolean }>`
    &:before,
    &:after {
      content: '';
      display: block;
    }

    ${({ showLabel }) =>
      showLabel &&
      css`
        &:before {
          width: 100px;
          height: 20px;
          background: ${tokens.color.neutral_200};
          margin-bottom: ${tokens.spacer.x1};
        }
      `}

    &:after {
      height: 40px;
      margin-right: ${tokens.spacer.x2};
      margin-bottom: ${tokens.spacer.x3};
      border-radius: ${tokens.radius.m};
      background: ${tokens.color.neutral_200};
    }
  `,
};

export const CreditCardDetailsLoader = (): JSX.Element => (
  <S.Container>
    <S.Anitmation>
      <S.Fieldset showLabel={false} style={{ flexBasis: '50%', marginRight: '50%' }} />

      <S.Fieldset showLabel style={{ flexBasis: '40%' }} />
      <S.Fieldset showLabel style={{ flexBasis: '30%' }} />
      <S.Fieldset showLabel style={{ flexBasis: '30%' }} />

      <S.Fieldset showLabel style={{ flexBasis: '75%', marginRight: '25%' }} />

      <S.Fieldset showLabel style={{ flexBasis: '40%' }} />
      <S.Fieldset showLabel style={{ flexBasis: '30%' }} />
      <S.Fieldset showLabel style={{ flexBasis: '30%' }} />

      <S.Fieldset showLabel={false} style={{ width: '150px' }} />
    </S.Anitmation>
  </S.Container>
);
